module.exports = __webpack_public_path__ + "img/访客管理.a027c7b5.svg";